<div class="editor">
  <header class="editor__testa">
    <button type="button" class="editor__indietro" mat-button (click)="tornaAllElenco()">
      <mat-icon>arrow_back</mat-icon>
      Articoli
    </button>

    <div class="editor__identita">
      <h1 class="editor__titolo-pagina">{{ titoloPagina() }}</h1>
      @if (editItemForm.controls['id'].value) {
        @if (stato(); as s) {
          <span class="stato stato--{{ s.codice }}">{{ s.etichetta }}</span>
        }
      }
    </div>

    @if (editItemForm.controls['id'].value) {
      <div class="editor__azioni-testa">
        <button type="button" mat-icon-button [matMenuTriggerFor]="menuArticolo" aria-label="Altre azioni">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menuArticolo="matMenu" xPosition="before">
          <!-- Sotto i 600px il gruppo nel piede si nasconde e comanda questo
               menu: le stesse condizioni, altrimenti su telefono "Visualizza
               sul sito" ricomparirebbe subito dopo il salvataggio. -->
          @if (mostraAzioniSito()) {
            <button type="button" mat-menu-item class="editor__menu-sito" (click)="apriSulSito(true)">
              <mat-icon>autorenew</mat-icon>
              <span>Aggiorna cache</span>
            </button>
            <button
              type="button"
              mat-menu-item
              class="editor__menu-sito"
              [disabled]="condiviso()"
              (click)="pubblicaSuiSocial()"
            >
              <mat-icon>share</mat-icon>
              <span>{{ condiviso() ? 'Già condiviso sui social' : 'Condividi sui social' }}</span>
            </button>
          }
          @if (mostraVisualizzaSulSito()) {
            <button type="button" mat-menu-item class="editor__menu-sito" (click)="apriSulSito()">
              <mat-icon>open_in_new</mat-icon>
              <span>Visualizza sul sito</span>
            </button>
          }
          @if (stato().codice !== 'bozza') {
            <button type="button" mat-menu-item (click)="riportaInBozza()">
              <mat-icon>unpublished</mat-icon>
              <span>Riporta in bozza</span>
            </button>
          }
          @if (authService.user?.can('owners')) {
            <button type="button" mat-menu-item (click)="elimina()">
              <mat-icon>delete</mat-icon>
              <span>Elimina</span>
            </button>
          }
        </mat-menu>
      </div>
    }
  </header>

  @if (caricamento()) {
    <div class="editor__attesa" role="status">
      <mat-progress-bar mode="indeterminate" aria-label="Caricamento dell’articolo" />
      <p>Caricamento dell'articolo…</p>
    </div>
  } @else {
    <form class="editor__corpo" [formGroup]="editItemForm">
      <!-- ================= Colonna del testo ================= -->
      <div class="editor__principale">
        @if (editItem?.cognome_esterno) {
          <div class="editor__avviso-esterno">
            <mat-icon aria-hidden="true">mark_email_read</mat-icon>
            <div>
              <p class="editor__avviso-titolo">Arrivato dall'esterno</p>
              <p>
                Inviato da <strong>{{ editItem?.nome_esterno }} {{ editItem?.cognome_esterno }}</strong>
                ({{ editItem?.email_esterno }}). Revisiona il testo e scegli la data di pubblicazione.
              </p>
            </div>
          </div>
        }

        <div id="campo-titolo" class="editor__campo-titolo">
          <mat-form-field class="editor__largo">
            <mat-label>Titolo</mat-label>
            <!-- Niente `maxlength`: smetteva di accettare caratteri senza dire
                 niente, e chi scriveva si ritrovava il titolo troncato senza
                 accorgersene. Ora si puo' scrivere oltre, l'avviso compare
                 subito e la pubblicazione resta bloccata finche' non rientra. -->
            <input
              matInput
              formControlName="titolo"
              [attr.aria-invalid]="titoloTroppoLungo()"
              [attr.aria-describedby]="titoloTroppoLungo() ? 'avviso-titolo-lungo' : null"
              (input)="onInputTitle($event)"
              (blur)="controllaTitoloDuplicato()"
            />
            <!-- `maxlength` blocca la scrittura, non tronca quello che c'era: un
                 articolo vecchio con 187 caratteri li tiene e si salva. Il
                 contatore lo dice invece di sembrare rotto. -->
            <mat-hint align="end" [class.editor__contatore--oltre]="titoloTroppoLungo()">
              {{ lunghezzaTitolo() }}/{{ massimoTitolo }}
            </mat-hint>
          </mat-form-field>

          @if (titoloTroppoLungo()) {
            <p class="editor__avviso-riga editor__avviso-riga--errore" id="avviso-titolo-lungo" role="alert">
              <mat-icon aria-hidden="true">error</mat-icon>
              <span>
                Attenzione: è stato superato il limite massimo di {{ massimoTitolo }} battute.
                Ridurre la lunghezza del titolo prima di procedere.
              </span>
            </p>
          }

          @if (titoloDuplicato(); as altroId) {
            <p class="editor__avviso-riga">
              <mat-icon aria-hidden="true">warning_amber</mat-icon>
              Esiste già un articolo con questo titolo (ID {{ altroId }}).
            </p>
          }
        </div>

        <div id="campo-permalink" class="editor__permalink">
          <mat-form-field class="editor__largo">
            <mat-label>Permalink</mat-label>
            <input matInput formControlName="permalink" />
            <mat-hint>Si compone dal titolo e resta fisso dopo il primo salvataggio.</mat-hint>
          </mat-form-field>
        </div>

        <div id="campo-testo" class="editor__testo">
          @if (editorPronto()) {
          <quill-editor
            #quillEditor
            [modules]="editorModules"
            formControlName="testo"
            (onEditorCreated)="editorCreato($event)"
            (onContentChanged)="preparaVideoTrascinabili()"
          ></quill-editor>
          }
        </div>

        @if (editItemForm.controls['id'].value && authService.user?.can('owners')) {
          <section class="editor__chat">
            <h2 class="etichetta">Chat con l'editor</h2>
            <mat-form-field class="editor__largo">
              <mat-label>Cosa vuoi cambiare</mat-label>
              <textarea
                matInput
                rows="4"
                formControlName="chat_con_editor"
                [disabled]="!editItemForm.controls['testo'].value"
                placeholder="Es. accorcia il primo paragrafo e aggiungi un intertitolo prima della dichiarazione"
              ></textarea>
            </mat-form-field>
            <button
              type="button"
              mat-flat-button
              color="primary"
              [disabled]="
                chatInCorso() !== null ||
                generazioneInCorso() !== null ||
                formattazioneInCorso() ||
                !editItemForm.controls['testo'].value ||
                !editItemForm.controls['chat_con_editor'].value
              "
              (click)="submitEditorChat()"
            >
              <mat-icon>auto_fix_high</mat-icon>
              {{ chatInCorso() !== null ? avanzamento(chatInCorso()) : 'Applica' }}
            </button>
          </section>
        }
      </div>

      <!-- ================= Colonna laterale ================= -->
      <aside class="editor__lato">
        <!-- Lista di controllo: al posto del messaggio unico "compila tutti i campi" -->
        <section class="scheda scheda--fitta editor__controllo">
          <h2 class="etichetta">Prima di pubblicare</h2>
          @if (mancanti().length === 0) {
            <p class="editor__controllo-ok">
              <mat-icon aria-hidden="true">check_circle</mat-icon>
              Non manca niente.
            </p>
          } @else {
            <ul class="editor__controllo-elenco">
              @for (requisito of mancanti(); track requisito.campo) {
                <li>
                  <button type="button" class="editor__controllo-voce" (click)="vaiAlCampo(requisito.campo)">
                    <mat-icon aria-hidden="true">radio_button_unchecked</mat-icon>
                    {{ requisito.etichetta }}
                  </button>
                </li>
              }
            </ul>
          }
        </section>

        <!-- Assistente -->
        <details class="pannello" open>
          <summary class="pannello__testa">Assistente</summary>
          <div class="pannello__corpo">
            @if (authService.user?.can('owners')) {
              <button
                type="button"
                mat-stroked-button
                class="editor__largo"
                [disabled]="generazioneInCorso() !== null || chatInCorso() !== null || formattazioneInCorso()"
                (click)="generaTesto()"
              >
                <mat-icon>auto_fix_high</mat-icon>
                {{
                  generazioneInCorso() !== null
                    ? avanzamento(generazioneInCorso())
                    : !editItemForm.controls['testo'].value
                      ? 'Genera testo'
                      : 'Migliora testo'
                }}
              </button>
            }
            <button
              type="button"
              mat-stroked-button
              class="editor__largo"
              [disabled]="formattazioneInCorso() || !editItemForm.controls['testo'].value"
              (click)="miglioraFormattazione()"
            >
              <mat-icon>auto_fix_normal</mat-icon>
              {{
                formattazioneInCorso()
                  ? tentativoFormattazione() > 1
                    ? 'Riprovo… (' + tentativoFormattazione() + '/3)'
                    : 'Formatto…'
                  : 'Migliora formattazione'
              }}
            </button>
          </div>
        </details>

        <!-- Copertina -->
        <details class="pannello" id="campo-copertina" open>
          <summary class="pannello__testa">Copertina</summary>
          <div class="pannello__corpo">
            <div
              class="copertina"
              [class.copertina--ok]="uploadSuccess"
              [class.copertina--errore]="uploadError"
              (drop)="onFileDrop($event)"
              (dragover)="onDragOver($event)"
            >
              <input type="file" accept="image/*" (change)="onFileChange($event)" hidden #fileInput />

              <!-- Riquadro 16:9: e' la proporzione che chiediamo, quindi
                   l'anteprima mostra anche come verra' tagliata. -->
              <button type="button" class="copertina__bersaglio" (click)="fileInput.click()">
                @if (imagePreview()) {
                  <img class="copertina__anteprima" [src]="imagePreview()" alt="Anteprima della copertina" />
                } @else {
                  <mat-icon aria-hidden="true">add_photo_alternate</mat-icon>
                  <span>Clicca o trascina qui l'immagine</span>
                }
              </button>

              @if (imagePreview()) {
                <div class="copertina__riga">
                  <!-- Il nome e' spesso un hash di ventidue caratteri: si
                       accorcia, e per intero sta nel titolo. -->
                  <span class="copertina__nome" [title]="imageName()">{{ imageName() }}</span>
                  @if (fileSize()) {
                    <span class="copertina__peso">{{ fileSize() }} KB</span>
                  }
                  <button type="button" mat-icon-button aria-label="Togli l'immagine" matTooltip="Togli l'immagine" (click)="removeImage()">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>

            <!--
              Avviso sulle dimensioni. Non blocca il salvataggio: la decisione
              resta alla redazione. Prima erano quindici righe di testo dentro
              il form; ora l'esito sta in una riga e la spiegazione si apre a
              richiesta.
            -->
            <!--
              Avviso sulle dimensioni della copertina. Non blocca il
              salvataggio: la decisione resta alla redazione.
            -->
            @if (avvisoImmagine(); as avviso) {
              <div class="avviso-copertina">
                <p class="avviso-copertina__intestazione">
                  <mat-icon aria-hidden="true">warning_amber</mat-icon>
                  Immagine troppo piccola per Google Discover
                </p>

                <p class="avviso-copertina__misura">
                  Hai caricato <strong>{{ avviso.larghezza }}&times;{{ avviso.altezza }} px</strong>
                  ({{ avviso.pixel | number }} pixel totali). Usa <strong>1200&times;675 px</strong> oppure più grande,
                  mantenendo la proporzione 16:9.
                </p>

                <ul class="avviso-copertina__elenco">
                  @if (avviso.larghezzaInsufficiente) {
                    <li>
                      La larghezza minima richiesta da Google è <strong>1200 px</strong>: questa è di
                      {{ avviso.larghezza }} px.
                    </li>
                  }
                  @if (avviso.pixelInsufficienti) {
                    <li>
                      Servono più di <strong>300.000 pixel</strong> totali: questa ne ha
                      {{ avviso.pixel | number }}.
                    </li>
                  }
                  @if (avviso.proporzioneErrata) {
                    <li>
                      La proporzione deve essere <strong>16:9</strong>, cioè larghezza circa 1,78 volte l'altezza
                      (1200&times;675, 1600&times;900).
                    </li>
                  }
                </ul>

                <p class="avviso-copertina__perche">
                  <strong>Perché serve.</strong> Google Discover è il feed di articoli suggeriti su smartphone e
                  nell'app Google, ed è guidato dalle immagini: se la copertina non raggiunge quelle misure, l'articolo
                  non ottiene l'anteprima a immagine grande e in pratica non viene proposto. Negli ultimi tre mesi
                  Discover ha portato <strong>zero</strong> visite a InfoOggi, mentre Facebook ne porta circa 850 al
                  giorno con lo stesso tipo di contenuti. Le stesse misure valgono anche per le anteprime su Facebook,
                  WhatsApp e Telegram, che oggi risultano sfocate perché ingrandite da un originale piccolo.
                </p>

                <p class="avviso-copertina__nota">
                  Caricare grande non appesantisce il sito: il CDN ridimensiona da solo le versioni piccole per gli
                  elenchi e le anteprime. L'immagine puoi salvarla comunque, questo è solo un avviso.
                </p>
              </div>
            }

            @if (immagineConforme()) {
              <p class="avviso-copertina avviso-copertina--ok">
                <mat-icon aria-hidden="true">check_circle</mat-icon>
                Dimensioni adatte a Discover e alle anteprime social.
              </p>
            }
          </div>
        </details>

        <!-- Pubblicazione -->
        <details class="pannello" open>
          <summary class="pannello__testa">Pubblicazione</summary>
          <div class="pannello__corpo">
            <mat-form-field class="editor__largo" id="campo-data">
              <mat-label>Data e ora</mat-label>
              <input matInput type="datetime-local" formControlName="data" />
              <mat-hint>Una data futura tiene l'articolo programmato.</mat-hint>
            </mat-form-field>

            <mat-form-field class="editor__largo">
              <mat-label>Primo piano nazionale</mat-label>
              <mat-select formControlName="evidenza">
                <mat-option [value]="'0'">No</mat-option>
                <mat-option [value]="'1'">Si</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </details>

        <!-- Classificazione -->
        <details class="pannello" open>
          <summary class="pannello__testa">Classificazione</summary>
          <div class="pannello__corpo">
            <mat-form-field class="editor__largo" id="campo-categoria">
              <mat-label>Categoria</mat-label>
              <input matInput formControlName="categoria" [matAutocomplete]="autoCategoria" autocomplete="off" />
              <mat-autocomplete #autoCategoria="matAutocomplete" [displayWith]="nomeCategoria">
                @for (categoria of categorieDetailDataSource | async; track categoria.id) {
                  <mat-option [value]="categoria">{{ categoria.nome }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="editor__largo" id="campo-autore">
              <mat-label>Autore</mat-label>
              <input matInput formControlName="autore" [matAutocomplete]="autoAutore" autocomplete="off" />
              <mat-autocomplete #autoAutore="matAutocomplete" [displayWith]="nomeAutore">
                @for (autore of autoriDetailDataSource | async; track autore.id) {
                  <mat-option [value]="autore">{{ autore.blogger }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="editor__largo" id="campo-regione">
              <mat-label>Regione</mat-label>
              <mat-select formControlName="regione" [compareWith]="utilsService.compareById" (selectionChange)="onChangeRegione($event)">
                @for (r of regioniDataSource; track r.id) {
                  <mat-option [value]="r">{{ r.nomeregione }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="editor__largo" id="campo-provincia">
              <mat-label>Provincia</mat-label>
              <mat-select formControlName="provincia" [compareWith]="utilsService.compareById">
                @for (p of provinceFilteredDataSource; track p.id) {
                  <mat-option [value]="p">{{ p.nomeprovincia }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </details>

        <!-- SEO -->
        <details class="pannello" id="campo-keywords" open>
          <summary class="pannello__testa">SEO</summary>
          <div class="pannello__corpo">
            <mat-form-field class="editor__largo">
              <mat-label>Keywords</mat-label>
              <input matInput formControlName="keywords" />
              <mat-hint>Separate da uno spazio, senza caratteri speciali.</mat-hint>
            </mat-form-field>
            <button
              type="button"
              mat-stroked-button
              class="editor__largo"
              [disabled]="!editItemForm.controls['testo'].value || keywordsInCorso()"
              (click)="generaKeywords()"
            >
              @if (keywordsInCorso()) {
                <mat-icon class="editor__icona-che-gira">autorenew</mat-icon>
                Genero le keywords…
              } @else {
                <mat-icon>auto_fix_high</mat-icon>
                Genera keywords
              }
            </button>
          </div>
        </details>
      </aside>
    </form>
  }

  <footer class="editor__piede">
    <!-- I pulsanti stanno a sinistra, dove finisce il testo dell'articolo e
         dove il cursore gia' si trova: prima erano in fondo a destra, lontani
         dalla colonna che si sta scrivendo. Lo stato del salvataggio e' una
         nota, non un'azione, e va dall'altra parte. -->
    <!-- L'ordine e' quello in cui si lavora: si salva, si pubblica, si
         rigenera la cache, si condivide, si guarda, si esce. La guida illumina
         il primo passo che ha ancora senso — lo decide lo stato dell'articolo,
         non un contatore — e gli altri restano premibili: e' un suggerimento,
         non un binario. -->
    <div class="editor__piede-azioni" role="group" aria-label="Azioni sull’articolo">
      <button
        type="button"
        mat-stroked-button
        class="editor__passo"
        [class.editor__passo--ora]="guidato('salva')"
        [attr.aria-current]="guidato('salva') ? 'step' : null"
        [disabled]="salvataggioInCorso()"
        (click)="salvaBozza()"
      >
        Salva
      </button>

      <button
        type="button"
        mat-flat-button
        color="primary"
        class="editor__passo"
        [class.editor__passo--ora]="guidato('pubblica')"
        [attr.aria-current]="guidato('pubblica') ? 'step' : null"
        [disabled]="!puoPubblicare() || salvataggioInCorso() || stato().codice !== 'bozza'"
        disabledInteractive
        [matTooltip]="
          !editItemForm.controls['id'].value
            ? 'Salva l’articolo prima di pubblicarlo'
            : mancanti().length
              ? 'Manca ancora qualcosa: guarda la lista a destra'
              : ''
        "
        (click)="pubblica()"
      >
        Pubblica
      </button>

      <!-- Le azioni sulla pagina pubblica compaiono solo quando una pagina
           pubblica c'e'. Prima bastava che l'articolo avesse un id, cioe' il
           primo salvataggio: su una bozza si offriva di rigenerare la cache di
           qualcosa che non esisteva. -->
      @if (mostraAzioniSito()) {
        <div class="editor__sito">
          <button
            type="button"
            mat-flat-button
            class="editor__sito-azione editor__sito-azione--cache editor__passo"
            [class.editor__passo--ora]="guidato('cache')"
            [attr.aria-current]="guidato('cache') ? 'step' : null"
            aria-label="Aggiorna cache"
            matTooltip="Riapre la pagina costringendo il sito a rigenerarla"
            (click)="apriSulSito(true)"
          >
            <mat-icon>autorenew</mat-icon>
            <span class="editor__sito-etichetta">Aggiorna cache</span>
          </button>

          <!-- Condiviso una volta, non si ricondivide: al posto di un pulsante
               spento senza spiegazione ci sta scritto che e' gia' fatto. -->
          @if (condiviso()) {
            <span class="editor__sito-fatto">
              <mat-icon aria-hidden="true">check_circle</mat-icon>
              <span class="editor__sito-etichetta">Già condiviso sui social</span>
            </span>
          } @else {
            <button
              type="button"
              mat-flat-button
              class="editor__sito-azione editor__sito-azione--social editor__passo"
              [class.editor__passo--ora]="guidato('social')"
              [attr.aria-current]="guidato('social') ? 'step' : null"
              aria-label="Condividi sui social"
              [disabled]="stato().codice !== 'pubblicato'"
              disabledInteractive
              [matTooltip]="
                stato().codice === 'pubblicato'
                  ? 'Condivide l’articolo sui canali social'
                  : 'Prima l’articolo deve essere online: i social salverebbero un’anteprima vuota'
              "
              (click)="pubblicaSuiSocial()"
            >
              <mat-icon>share</mat-icon>
              <span class="editor__sito-etichetta">Condividi sui social</span>
            </button>
          }

          <!-- Ultimo della fila, e non solo per ordine: aprire la pagina prima
               della condivisione scalda la cache con una versione che i social
               non hanno ancora letto, e l'anteprima che si portano dietro e'
               quella che trovano al primo passaggio. -->
          @if (mostraVisualizzaSulSito()) {
            <button
              type="button"
              mat-flat-button
              class="editor__sito-azione editor__sito-azione--pagina editor__passo"
              [class.editor__passo--ora]="guidato('sito')"
              [attr.aria-current]="guidato('sito') ? 'step' : null"
              aria-label="Visualizza sul sito"
              matTooltip="Apre la pagina pubblica in una scheda nuova"
              (click)="apriSulSito()"
            >
              <mat-icon>open_in_new</mat-icon>
              <span class="editor__sito-etichetta">Visualizza sul sito</span>
            </button>
          }
        </div>
      }

      <!-- L'uscita, in fondo alla sequenza: in fondo a un articolo lungo la
           testa e' fuori schermo, e per uscire si doveva risalire. -->
      <button
        type="button"
        mat-stroked-button
        class="editor__piede-indietro editor__passo"
        [class.editor__passo--ora]="guidato('articoli')"
        [attr.aria-current]="guidato('articoli') ? 'step' : null"
        (click)="tornaAllElenco()"
      >
        <mat-icon>arrow_back</mat-icon>
        <span class="editor__sito-etichetta">Articoli</span>
      </button>
    </div>

    <span class="editor__stato-salvataggio">{{ statoSalvataggio() }}</span>
  </footer>
</div>
